import { useEffect, useState } from "react";

export const useNow = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let frame: any;

    const tick = () => {
      const ms = Date.now();
      setNow(ms);

      const delay = 1000 - (ms % 1000);
      frame = setTimeout(tick, delay);
    };

    tick();

    return () => clearTimeout(frame);
  }, []);

  return now;
};
